module.exports = __webpack_public_path__ + "static/media/reactnative.bbdf00dc.png";